// extracted by mini-css-extract-plugin
export default {"content":"ProjectDescriptiom_content__5T4js","description":"ProjectDescriptiom_description__ndeCc","analytic":"ProjectDescriptiom_analytic__ewmhF"};